import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { slotTemplateQKeys } from "@hooks/queries/slotTemplate/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useGenerateSlots = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ templateId }: { templateId: string }) => {
      return api.post(`slot-templates/${templateId}/generate`);
    },

    onSuccess: () => {
      showSuccessNotification({ message: "slots-generated-successfully" });
      queryClient.invalidateQueries({ queryKey: slotTemplateQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Generate Slots]", res);
      handleErrors(res, "mutation");
    },
  });
};
